import React from "react";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";

// ---------------------------------------------------------------
// PROVIDER NOTES — vom Betreiber zu bestätigen bzw. anzupassen.
// Diese Website wird über die Emergent-Plattform bereitgestellt,
// die Cloud-Speicher (Object Storage) und den Zugriff auf einen
// KI-Vision-Dienst (Claude Sonnet 4.5 von Anthropic) vermittelt.
// Rechtlich relevant sind die AV-Verträge und Sub-Unternehmer der
// Emergent-Plattform. Wo unten „⚠ Anbieter noch zu bestätigen"
// steht, bitte durch die vom Anbieter offiziell bereitgestellten
// Angaben ersetzen, bevor die Seite veröffentlicht bzw. produktiv
// eingesetzt wird.
// ---------------------------------------------------------------

const HOSTING_NOTE = "\u26A0 Anbieter noch zu best\u00E4tigen: Diese Seite wird \u00FCber die Emergent-Plattform bereitgestellt. Bitte den Firmensitz und den Unterauftragsverarbeiter (Cloud-Infrastruktur) beim Anbieter erfragen und hier eintragen.";
const STORAGE_NOTE = "\u26A0 Anbieter noch zu best\u00E4tigen: Emergent Object Storage (Cloud-Speicher der Emergent-Plattform).";
const AI_NOTE = "KI-Vision-Anbieter: Anthropic PBC, San Francisco, USA (Modell \u201EClaude Sonnet 4.5\u201C). Der Zugriff erfolgt \u00FCber die Emergent-Plattform.";

export default function Datenschutz() {
  const owner = "Mehmet Kuruçam";
  const address = "Pontstraße 101, 52062 Aachen";
  const phone = "+49 176 56198464";
  const phoneDigits = phone.replace(/\D/g, "");
  const email = "leukasumzug@gmail.com";
  const emailLink = <a href={`mailto:${email}`} className="text-brand-amberDark">{email}</a>;
  const stand = new Date().toLocaleDateString("de-DE");

  const sections = [
    {
      title: "1. Verantwortlicher",
      body: (
        <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-1.5">
          <div><span className="font-semibold">Firma:</span> Leukas Umzug Service</div>
          <div><span className="font-semibold">Inhaber:</span> {owner}</div>
          <div><span className="font-semibold">Adresse:</span> {address}</div>
          <div><span className="font-semibold">Telefon:</span> <a href={`tel:+${phoneDigits}`} className="text-brand-amberDark">{phone}</a></div>
          <div><span className="font-semibold">WhatsApp:</span> <a href={`https://wa.me/${phoneDigits}`} className="text-brand-amberDark">{phone}</a></div>
          <div><span className="font-semibold">E-Mail:</span> {emailLink}</div>
        </div>
      ),
    },
    {
      title: "2. Allgemeine Hinweise",
      body: (
        <p>
          Wir verarbeiten personenbezogene Daten ausschließlich in Übereinstimmung mit den Vorgaben
          der Datenschutz-Grundverordnung (DSGVO) und des Bundesdatenschutzgesetzes (BDSG).
          Erhoben werden nur Daten, die für die Angebotserstellung, die Vertragsabwicklung und den
          Betrieb der Website erforderlich sind. Die Übertragung sämtlicher Formulardaten erfolgt
          verschlüsselt über TLS/SSL (HTTPS).
        </p>
      ),
    },
    {
      title: "3. Hosting und Server-Logfiles",
      body: (
        <div className="space-y-2">
          <p>{HOSTING_NOTE}</p>
          <p>
            Mit dem Hosting-Anbieter besteht ein Vertrag zur Auftragsverarbeitung nach Art. 28 DSGVO.
            Beim Aufruf der Website werden aus technischen und sicherheitsbezogenen Gründen
            automatisch Server-Logfiles erhoben (IP-Adresse, Zeitstempel, abgerufene URL,
            User-Agent, Referrer). Diese Daten werden für maximal 30 Tage gespeichert und danach
            gelöscht. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
            Stabilität und Sicherheit der Website).
          </p>
        </div>
      ),
    },
    {
      title: "4. Angebotsformulare (Umzug und Entrümpelung)",
      body: (
        <div className="space-y-2">
          <p>
            Wenn Sie ein Angebot über <a href="/angebot" className="text-brand-amberDark">/angebot</a>{" "}
            oder <a href="/entruempelung" className="text-brand-amberDark">/entruempelung</a> anfragen,
            verarbeiten wir folgende Daten:
          </p>
          <ul className="list-disc list-inside space-y-1">
            <li>Umzug/Transport: Vor- und Nachname, Telefonnummer, ggf. WhatsApp-Nummer, Abhol- und Lieferadresse, Etage und Aufzugsangaben, Wunschtermin und Uhrzeit, ggf. optionale Nachricht sowie hochgeladene Fotos.</li>
            <li>Entrümpelung: Name, Telefonnummer, E-Mail-Adresse, Adresse/PLZ, Objektart, Größe in m², Etage und Aufzugsangaben, Zusatzleistungen, Wunschtermin, ggf. Nachricht sowie hochgeladene Fotos.</li>
          </ul>
          <p>
            Zweck: Vorbereitung und Erfüllung des Angebots bzw. des daraus resultierenden Vertrags.
            Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO. Die Daten werden 6 Monate nach Ihrer Anfrage
            gelöscht, sofern kein Vertrag zustande kommt. Kommt ein Vertrag zustande, gelten die
            gesetzlichen Aufbewahrungsfristen (§ 147 AO, § 257 HGB — 6 bis 10 Jahre).
          </p>
        </div>
      ),
    },
    {
      title: "5. Foto-Uploads",
      body: (
        <div className="space-y-2">
          <p>
            Hochgeladene Fotos werden verschlüsselt in einem Cloud-Speicher abgelegt und
            ausschließlich zur Erstellung Ihres Angebots verwendet. Nur autorisierte Mitarbeiter
            haben Zugriff. Auf Wunsch löschen wir die Bilder unverzüglich nach Auftragsabschluss.
          </p>
          <p>{STORAGE_NOTE} Mit dem Speicher-Anbieter besteht ein Auftragsverarbeitungsvertrag nach Art. 28 DSGVO.</p>
        </div>
      ),
    },
    {
      title: "6. KI-Bilderkennung (Foto-Schnellscan)",
      body: (
        <div className="space-y-2">
          <p>
            Wenn Sie unseren Foto-Schnellscan auf <a href="/scan" className="text-brand-amberDark">/scan</a>{" "}
            nutzen, wird Ihr Bild kurzzeitig an einen KI-Vision-Dienstleister übermittelt, der
            sichtbare Möbel und Gegenstände erkennt. Die Verarbeitung dient ausschließlich der
            Berechnung einer Preisspanne (Art. 6 Abs. 1 lit. b DSGVO). Eine automatisierte
            Entscheidungsfindung im Sinne des Art. 22 DSGVO sowie eine Profilbildung finden nicht statt.
          </p>
          <p>
            {AI_NOTE} Die Datenübertragung erfolgt in die USA. Als Übermittlungsgrundlage stützen
            wir uns auf das EU-US Data Privacy Framework bzw., soweit erforderlich, auf
            EU-Standardvertragsklauseln (Art. 46 DSGVO).
          </p>
        </div>
      ),
    },
    {
      title: "7. Kontaktaufnahme per Telefon, E-Mail und WhatsApp",
      body: (
        <div className="space-y-2">
          <p>
            Wenn Sie uns per Telefon, E-Mail oder WhatsApp kontaktieren, verarbeiten wir Ihre Angaben
            zur Bearbeitung Ihres Anliegens. Rechtsgrundlagen sind Art. 6 Abs. 1 lit. b DSGVO
            (vertragliche/vorvertragliche Maßnahmen) sowie Art. 6 Abs. 1 lit. a DSGVO (Einwilligung
            durch aktive Kontaktaufnahme).
          </p>
          <p>
            Nachrichten über WhatsApp werden von der WhatsApp Ireland Limited, 4 Grand Canal Square,
            Grand Canal Harbour, Dublin 2, Irland, sowie ihrem Mutterkonzern Meta Platforms verarbeitet.
            Dabei können personenbezogene Daten in die USA übermittelt werden. Als Übermittlungsgrundlage
            dienen das EU-US Data Privacy Framework und/oder die EU-Standardvertragsklauseln.
            Weitere Informationen finden Sie in der{" "}
            <a href="https://www.whatsapp.com/legal/privacy-policy-eea" target="_blank" rel="noreferrer" className="text-brand-amberDark">
              Datenschutzerklärung von WhatsApp
            </a>.
          </p>
        </div>
      ),
    },
    {
      title: "8. Cookies und lokale Speicherung",
      body: (
        <p>
          Nach § 25 TDDDG dürfen Informationen auf Ihrem Endgerät ohne Einwilligung nur gespeichert
          oder abgerufen werden, wenn dies für den ausdrücklich gewünschten Dienst technisch
          zwingend erforderlich ist. Auf dieser Website betrifft dies ausschließlich den technisch
          notwendigen Formularentwurf, den wir im „localStorage" Ihres Browsers zwischenspeichern,
          damit Sie eine unterbrochene Angebotsanfrage fortsetzen können. Alle anderen
          Speicher- und Auslesevorgänge, insbesondere für Marketing-, Tracking- und
          Reichweitenmessungszwecke (siehe Ziffer 9 und 10), erfolgen ausschließlich mit Ihrer
          vorherigen Einwilligung. Sie können den lokalen Speicher jederzeit über die Einstellungen
          Ihres Browsers löschen.
        </p>
      ),
    },
    {
      title: "9. Google Ads Conversion-Tracking und Google Tag",
      body: (
        <div className="space-y-2">
          <p>
            Anbieter: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland.
            Zweck: Wir messen mit dem Google Tag (gtag.js) und dem Google Ads Conversion-Tag, welche
            Werbeanzeige zu einer Anfrage geführt hat. Dabei werden Interaktionsdaten pseudonymisiert
            an Google übermittelt.
          </p>
          <p>
            Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO in Verbindung mit § 25 Abs. 1 TDDDG.
            Die Skripte werden erst nach Ihrer ausdrücklichen Einwilligung geladen. Bei der
            Verarbeitung kann eine Übermittlung in die USA erfolgen; als Übermittlungsgrundlage
            dient das EU-US Data Privacy Framework. Weitere Informationen unter{" "}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="text-brand-amberDark">
              policies.google.com/privacy
            </a>.
          </p>
          <p>
            Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft über die
            Cookie-Einstellungen widerrufen.
          </p>
        </div>
      ),
    },
    {
      title: "10. Meta-Pixel (Facebook Pixel)",
      body: (
        <div className="space-y-2">
          <p>
            Anbieter: Meta Platforms Ireland Limited, Merrion Road, Dublin 4, Irland.
            Zweck: Messung und Optimierung unserer Werbekampagnen. Das Meta-Pixel überträgt
            Interaktionsdaten (u.&nbsp;a. Seitenaufrufe, ausgefüllte Formulare) an Meta.
          </p>
          <p>
            Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO in Verbindung mit § 25 Abs. 1 TDDDG.
            Die Einbindung erfolgt erst nach Ihrer ausdrücklichen Einwilligung. Es kann eine
            Übermittlung in die USA stattfinden; als Übermittlungsgrundlage dient das
            EU-US Data Privacy Framework. Weitere Informationen unter{" "}
            <a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noreferrer" className="text-brand-amberDark">
              facebook.com/privacy/policy
            </a>.
          </p>
          <p>
            Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.
          </p>
        </div>
      ),
    },
    {
      title: "11. Empfänger und Auftragsverarbeiter",
      body: (
        <div className="space-y-2">
          <p>Wir übermitteln personenbezogene Daten an folgende Kategorien von Empfängern:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>Hosting-Anbieter (siehe Ziffer 3)</li>
            <li>Cloud-Speicher-Anbieter für Foto-Uploads (siehe Ziffer 5)</li>
            <li>KI-Vision-Anbieter für den Foto-Schnellscan (siehe Ziffer 6)</li>
            <li>Google Ireland Limited (siehe Ziffer 9)</li>
            <li>Meta Platforms Ireland Limited (siehe Ziffer 10)</li>
          </ul>
          <p>
            Soweit gesetzlich erforderlich, bestehen Verträge zur Auftragsverarbeitung nach
            Art. 28 DSGVO. Eine darüber hinausgehende Weitergabe erfolgt nicht.
          </p>
        </div>
      ),
    },
    {
      title: "12. Speicherdauer",
      body: (
        <p>
          Angebotsdaten werden 6 Monate nach Ihrer Anfrage gelöscht, sofern kein Vertrag zustande
          kommt. Kommt ein Vertrag zustande, gelten die gesetzlichen Aufbewahrungsfristen von 6
          bzw. 10 Jahren nach § 147 AO und § 257 HGB. Server-Logfiles werden nach maximal 30 Tagen
          gelöscht. Daten aus Einwilligungs-basierten Diensten (Ziffern 9 und 10) speichern die
          jeweiligen Anbieter nach ihren eigenen Richtlinien und Aufbewahrungsfristen.
        </p>
      ),
    },
    {
      title: "13. Ihre Rechte",
      body: (
        <div className="space-y-2">
          <p>
            Sie haben nach der DSGVO folgende Rechte: Auskunft (Art. 15), Berichtigung (Art. 16),
            Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit
            (Art. 20), Widerspruch (Art. 21) und Beschwerde bei einer Aufsichtsbehörde (Art. 77).
          </p>
          <p>
            <span className="font-semibold">Widerspruchsrecht:</span> Soweit wir Ihre Daten auf
            Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen) verarbeiten, können Sie
            jederzeit Widerspruch gegen die Verarbeitung einlegen. Nach Ihrem Widerspruch werden wir
            die Verarbeitung nicht mehr durchführen, es sei denn, wir können zwingende schutzwürdige
            Gründe für die Verarbeitung nachweisen, die Ihren Interessen, Rechten und Freiheiten
            überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung
            von Rechtsansprüchen.
          </p>
          <p>Zuständige Aufsichtsbehörde:</p>
          <div className="rounded-xl border border-slate-200 bg-white p-5 space-y-0.5">
            <div>Landesbeauftragte für Datenschutz und Informationsfreiheit</div>
            <div>Nordrhein-Westfalen</div>
            <div>Kavalleriestraße 2–4</div>
            <div>40213 Düsseldorf</div>
          </div>
        </div>
      ),
    },
    {
      title: "14. Keine automatisierte Entscheidungsfindung",
      body: (
        <p>
          Eine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne des Art. 22
          DSGVO findet nicht statt.
        </p>
      ),
    },
    {
      title: "15. Bereitstellung der Daten",
      body: (
        <p>
          Die Bereitstellung Ihrer Daten ist freiwillig. Ohne die als Pflichtfelder markierten
          Angaben können wir jedoch keine Angebotserstellung durchführen und Ihre Anfrage nicht
          bearbeiten.
        </p>
      ),
    },
    {
      title: "16. Änderungen dieser Datenschutzerklärung",
      body: (
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich die Rechtslage,
          unsere Angebote oder die Datenverarbeitung ändern. Es gilt jeweils die aktuelle, auf
          dieser Seite veröffentlichte Fassung. <span className="font-semibold">Stand: {stand}</span>.
        </p>
      ),
    },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SiteHeader />
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="text-xs font-bold uppercase tracking-widest text-brand-amberDark">Rechtliches</div>
        <h1 className="mt-2 text-3xl sm:text-4xl font-heading font-bold text-slate-900">Datenschutzerklärung</h1>

        <div className="mt-8 space-y-6 text-slate-700 leading-relaxed">
          {sections.map((s, i) => (
            <section key={i}>
              <h2 className="text-xl font-heading font-semibold text-slate-900 mb-2">{s.title}</h2>
              {s.body}
            </section>
          ))}
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
